module.exports = __webpack_public_path__ + "assets/images/pages/unleash/ball-1.png?998ecd2c";